import { asStringArray, mapDtoList, requireObject, requireString } from './parse.js';

/**
 * Mirrors com.medprompt.identity.team.TeamData
 *
 * @typedef {object} TeamData
 * @property {string} teamId
 * @property {string} teamName
 * @property {string[]} userIds
 */

/**
 * @param {object} raw
 * @returns {TeamData}
 */
export function fromTeamData(raw) {
  const source = requireObject(raw, 'TeamData');
  return {
    teamId: requireString(source, 'teamId', 'TeamData'),
    teamName: requireString(source, 'teamName', 'TeamData'),
    userIds: asStringArray(source.userIds),
  };
}

/**
 * @param {unknown} raw
 * @returns {TeamData[]}
 */
export function fromTeamDataList(raw) {
  return mapDtoList(raw, 'TeamData', fromTeamData);
}

/**
 * Mirrors com.medprompt.identity.team.TeamOnboardRequest
 *
 * @param {{ teamName: string }} fields
 * @returns {{ teamName: string }}
 */
export function toTeamOnboardRequest({ teamName }) {
  if (typeof teamName !== 'string' || teamName.trim() === '') {
    throw new Error('TeamOnboardRequest: teamName is required');
  }
  return { teamName };
}

/**
 * Mirrors com.medprompt.identity.team.TeamUpdate
 *
 * @param {{ teamId: string, teamName?: string, addedUserIds?: string[], removedUserIds?: string[], clinicId?: string }} fields
 * @returns {object}
 */
export function toTeamUpdate(fields) {
  if (typeof fields?.teamId !== 'string' || !fields.teamId) {
    throw new Error('TeamUpdate: teamId is required');
  }
  const body = { teamId: fields.teamId };
  if (fields.teamName !== undefined) {
    body.teamName = fields.teamName;
  }
  if (fields.addedUserIds !== undefined) {
    body.addedUserIds = fields.addedUserIds;
  }
  if (fields.removedUserIds !== undefined) {
    body.removedUserIds = fields.removedUserIds;
  }
  if (fields.clinicId !== undefined) {
    body.clinicId = fields.clinicId;
  }
  return body;
}
